import React from "react";
import LeadsContent from "../components/leads/leads-content";

const MyTeamLeads = () => {
  return <LeadsContent showMyTeamLeads pageTitle="My Team's Leads" />;
};

export default MyTeamLeads;
